// FE→BE seam for recommended games shown before a mobile search starts.
// Server counterpart: app/api/casino/games/recommended/route.ts
// Imports from `domain/` are type-only.
import type { RecommendedGamesResponse } from "@/domain/casino/listing/types"

const RECOMMENDED_GAMES_ENDPOINT = "/api/casino/games/recommended"

type RecommendedGamesRequestOptions = {
  signal?: AbortSignal
}

export async function fetchRecommendedGames(
  options: RecommendedGamesRequestOptions = {}
): Promise<RecommendedGamesResponse> {
  const response = await fetch(RECOMMENDED_GAMES_ENDPOINT, {
    signal: options.signal
  })

  if (!response.ok) {
    throw new Error(`Recommended games failed with status ${response.status}`)
  }

  return (await response.json()) as RecommendedGamesResponse
}
